<template>
  <form @submit.prevent="handleSubmit()" class="regular-form">

    <!-- Name -->
    <district-name-field
      v-model="$attrs.district.name"
      :error="$attrs.errors.district.name"
    />

    <!-- District -->
    <city-field
      v-model="$attrs.district.city"
      :error="$attrs.errors.district.city"
      v-show="!(formType == 'add' && $attrs.district.city)"
    />

    <div class="form-group text-center">
      <input class="btn btn-primary btn-lg" type="submit" :value="submitLabel">
    </div>
  </form>
</template>

<script>
import districtNameField from '@/components/forms/district/fields/DistrictName'
import cityField from '@/components/forms/district/fields/City'

export default {
  name: 'district-blank-form',
  inheritAttrs: false,
  props: {
    submitLabel: {
      type: String,
      default: 'Submit'
    },
    formType: {
      type: String,
      required: true
    }
  },
  components: {
    districtNameField,
    cityField
  },
  methods: {
    handleSubmit () {
      this.$emit('submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// DistrictBlankForm.vue?14d77909